import './instagram_dm_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramTextDMContent extends Monitoring.Models.SocialContents.InstagramDMContent
  getMainText: ->
    @data.content?.text
